import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    LinearProgress,
    Pagination,
    PaginationItem,
} from "@mui/material";
import { connect } from "react-redux";
import {
    ArrowBack,
    Arrowdown2,
    Forward,
    Peyment,
} from "../../../assets";
import {
    EmptyTable,
    FilterInput,
    Input,
    Layout,
    TableRowResponsive,
} from "../../components";
import { TransactionsController } from "../../controllers";
import { Helmet } from "react-helmet-async";
import { numberWithCommas } from "../../../core/utils";
function CustomInput({ onFocus, value, onChange, title, emptyState }: any) {
    return (
        <>
            <Input
                customFocus={onFocus}
                myStyle="w-100"
                title={title}
                value={value}
                onChange={onChange}
                emptyState={emptyState}
            />
        </>
    );
}
class Transactions extends TransactionsController {
    componentDidMount() {
        window.scrollTo(0, 0);
        this.getList();
    }
    render() {
        const {
            transactionsList,
            loading,
        } = this.state;
        return (
            <Layout title="تراکنش ها">
                <Helmet>
                    <title> تراکنش ها / بیمه زندگی هامرز</title>
                </Helmet>
                {loading ? (
                    <LinearProgress />
                ) : (
                    <>
                        <div className="policy-filter">
                            {/*  */}


                            <div className="policy-filter ">
                                <FilterInput showIcon icon={<Peyment />} title="تادیه" buttonTitle="پیش پرداخت " placeholder="پیش پرداخت" onClick={() => window.location.href = "/pre-payment"} str="" />
                            </div>
                        </div>

                        <div className="policy table-responsive scrollbar offers">
                            <table className="table hide-mobile">
                                <thead>
                                    <tr>
                                        <th scope="col">ردیف</th>
                                        <th scope="col">تراکنش</th>
                                        <th scope="col">تاریخ</th>
                                        <th scope="col">مبلغ </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {transactionsList?.list?.length > 0 &&
                                        transactionsList?.list?.map((item: any, index: number) => {
                                            return (
                                                <tr>
                                                    <th>{index + 1}</th>
                                                    <td>{item?.regard} </td>
                                                    <td>{item?.payment_date} </td>
                                                    <th>{numberWithCommas(item?.amount)}</th>
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>

                            {transactionsList?.list?.length > 0 ? (
                                <>
                                    {transactionsList?.list?.map((item: any, index: number) => {
                                        return (
                                            <Accordion className="policy-accordion hide-desktop">

                                                <AccordionSummary
                                                    expandIcon={<img src={Arrowdown2} alt="هامرز" />}
                                                    aria-controls="panel1a-content"
                                                    className="summsry"
                                                    id="panel1a-header"
                                                >
                                                    <TableRowResponsive title="ردیف" value={index + 1} />
                                                    <TableRowResponsive
                                                        title="تراکنش"
                                                        value={item?.regard}
                                                    />
                                                    <TableRowResponsive
                                                        title="تاریخ"
                                                        value={item?.payment_date}
                                                    />
                                                </AccordionSummary>
                                                <AccordionDetails
                                                    className="d-flex flex-wrap"
                                                >
                                                    <TableRowResponsive
                                                        title=" مبلغ "
                                                        value={numberWithCommas(item?.amount)}
                                                    />
                                                </AccordionDetails>
                                            </Accordion>
                                        );
                                    })}

                                    <Pagination
                                        className="custom-pagination"
                                        count={
                                            transactionsList?.total ? Math.ceil(transactionsList?.total / 10) : 1
                                        }
                                        page={transactionsList?.page_number}
                                        onChange={this.handleChangePage}
                                        size="small"
                                        renderItem={(item) => (
                                            <PaginationItem
                                                slots={{ previous: Forward, next: ArrowBack }}
                                                {...item}
                                            />
                                        )}
                                    />
                                </>
                            ) : (
                                <EmptyTable title="   تراکنشی ثبت نشده است " />
                            )}
                        </div>


                    </>
                )}
            </Layout>
        );
    }
}

const mapStateToProps = (dispatch: any) => {
    return {
        dispatch,
        dashboardData: dispatch.general.dashboardData,
    };
};

export default connect(mapStateToProps)(Transactions);
